import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { renderBonusBenefit } from './renderBonusBenefit.js';
export const renderBonusBenefits = (bonusBenefits, columnsCount, cardTextAlign) => (_jsx("div", { className: `grid gap-2xs ${getElementsColsValue(columnsCount)}`, children: bonusBenefits.map(renderBonusBenefit(cardTextAlign)) }));
const getElementsColsValue = (colValue) => {
    switch (colValue) {
        case '3':
            return 'grid-cols-3';
        case '4':
            return 'grid-cols-4';
        case '5':
            return 'grid-cols-5';
        default:
            return 'grid-cols-5';
    }
};
//# sourceMappingURL=renderBonusBenefits.js.map